import React, {useContext} from 'react';
import {TextField} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import {makeStyles} from "@material-ui/core/styles";
import {DataContext} from "../context/dataContext";


const useStyles = makeStyles(() => ({
    inputStyles: {
        fontSize: "1.3rem"
    }
}))

export default function TextArea() {

    const {textAreaValue, setTextAreaValue, setShowVariants, setSwitchData, setShowNickingTable} = useContext(DataContext)
    //console.log(switchState)
    const classes = useStyles();
    return (
        <>
            <Typography
                variant="body1"
                align="center"
                style={{ marginBottom: "0.75rem", color: "#000000" }}
            >
                <strong>Note:</strong> PRIDICT2.0 can <strong>predict pegRNAs with (silent) bystanders for replacement edits</strong>, which often boost editing efficiency in MMR+ settings.
                Try it via the toggle on the right — see our{" "}
                <Link
                    href="https://rdcu.be/eAIEQ"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "underline" }}
                >
                    Nature Protocols
                </Link>{" "}
                for details.
            </Typography>

            <TextField
                style={{
                    backgroundColor: "#E4E4E4"
                }}
                fullWidth
                multiline
                minRows={20}

                InputLabelProps={{
                    style: {color: '#8D8F9C',},
                }}
                InputProps={{disableUnderline: true}}
                variant={"filled"}
                inputProps={{
                    className: classes.inputStyles
                }}
                placeholder='Enter sequence in the following format:&#10;(100bp)-NNN (Sequence *before* edit / Sequence *after* edit) NNN-(100bp)&#10;Put unchanged bases flanking the edit *outside* of brackets (e.g. NNNA(G/C)TNNN instead of NNN(AGT/ACT)NNN)&#10;For deletions or insertions use "(-N)" or "(+N)" as placeholder.&#10;For further details select examples above.'
                value={textAreaValue}
                onChange={e => {
                    setSwitchData([false, false, false, false])
                    setShowVariants(false)
                    setShowNickingTable(false)
                    setTextAreaValue(e.target.value)
                    //console.log(switchState)
                }}
                id="textAreaField"
                name="textAreaField"
            />

        </>
    );
}
